if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        // console.log("this.variantIdInput",this.variantIdInput.value);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
       
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });

         var variantID =this.querySelector(".product-variant-id").value;
          var item_count = document.querySelector(".threshold_data").getAttribute("data-itemcount");
          console.log("item_count",item_count);
          // console.log("variantID",variantID);
          if(item_count == 0){
            console.log("Date-Time", new Date().getTime());
            localStorage.setItem("orderTime", new Date().getTime());
            updateCartTimer();
          }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

    toggleSubmitButton(disable = true, text) {
      const isPreorder = document.querySelector(
        'input[type="radio"]:checked[data-button-text="preorder"]'
      );

      let buttonText= "Add to cart";
      let current_Selected_var_input = document.querySelector(".variantbox-col input:checked");
      if(current_Selected_var_input && current_Selected_var_input.dataset.buttonText){
        buttonText = current_Selected_var_input.dataset.buttonText;
      }  

      // Update Sticky ATC button text
      document.querySelectorAll('.sticky_atc_btn').forEach((btn) => {
        btn.textContent = buttonText;
      });
      let product_form__submits = document.querySelectorAll(".product-form__submit span");

      product_form__submits.forEach((product_form__submit) => {
        product_form__submit.innerHTML = buttonText;
        product_form__submit.dataset.status = buttonText;
        if(product_form__submit.closest('.product-form__submit')){
          product_form__submit.closest('.product-form__submit').removeAttribute('disabled');
        }
      });
    
      let pdp_priorder_block = document.querySelector(".pdp-priorder-block"); 
      let dynamic_checkoutbtn_wrap = document.querySelector('.dynamic_checkoutbtn_wrap');
        
      if(current_Selected_var_input){
        let preorder_date = current_Selected_var_input.dataset.buttonDate;
        if(preorder_date){
          pdp_priorder_block.classList.remove('hide');
          let preorder_box_spans = document.querySelectorAll(".preorder-date");
          preorder_box_spans.forEach((preorder_box_span)=>{
            preorder_box_span.innerHTML = preorder_date;
          })
          if(dynamic_checkoutbtn_wrap)dynamic_checkoutbtn_wrap.classList.add('hide');
        }else{
          pdp_priorder_block.classList.add('hide');
          if(dynamic_checkoutbtn_wrap)dynamic_checkoutbtn_wrap.classList.remove('hide');
        }
      }

    }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
